import instagram from '../Components/Assets/instagram_icon.png'
import youtube from '../Components/Assets/youtube_icon.png'
import facebook from '../Components/Assets/facebook_icon.png'
import './CSS/Confirmation.css';
import { useEffect } from 'react';
import { updateInventory } from '../utils/inventoryService';

const Confirmation = () => {
  useEffect(() => {
    const updateDatabase = async () => {
      try {
        // Retrieve purchased items from session storage
        const purchasedItems = JSON.parse(sessionStorage.getItem('purchasedItems'));
        if (!purchasedItems || purchasedItems.length === 0) {
          console.log('No purchased items found in session storage.');
          return;
        }

        console.log('Updating inventory for purchased items:', purchasedItems);

        // Extract product IDs and quantities for inventory update
        const itemsForUpdate = purchasedItems.map(item => ({
          id: item.id,
          quantity: item.quantity
        }));

        // Send purchased items to the backend to update inventory
        const data = await updateInventory(itemsForUpdate, 'unknown'); // orderId would come from Square if available

        if (data.success) {
          console.log('Inventory updated successfully:', data);
          // Clear session storage after successful update
          sessionStorage.removeItem('purchasedItems');
        } else {
          console.error('Failed to update inventory:', data.error);
        }
      } catch (error) {
        console.error('Error updating inventory:', error.message);
      }
    };

    updateDatabase();
  }, []);

  return (
    <div className='confcontainer'>
      <div className="confirmation-page">
        <h1>Thank You for Your Purchase! Your receipt has been sent to your email for your records.</h1>
        <h2>Stay connected with us by following MarieMadeIt on social media for updates, new products, and Pattern tester calls.</h2>  
        <a className='social' href='https://www.instagram.com/mariemadeit__/?hl=en' _blank='target'><img src={instagram} alt='instagram-logo'/>Instagram</a>
        <a className='social' href='https://www.youtube.com/@MarieMadeIt96'><img src={youtube} alt='youtube-logo'/>Youtube</a>
        <a className='social' href='https://www.facebook.com/profile.php?id=100077528543304'><img src={facebook} alt='facebook-logo'/>Facebook</a>
        <p>Thank you once again for choosing MarieMadeIt!</p>
        <a className='returnbtn' href="/">Return Home</a>
      </div>
    </div>
  );
};

export default Confirmation;
